import React from 'react'

import { Button } from '@material-ui/core/'

import SystemMessageSnackbar from './SystemMessageSnackbar'
import {sendExternalInvite, sendPhoneInvite, SocialInvite} from "../Helpers/invites";

class InviteSent extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      reminded: false,

      systemMessage: {}
    }
  }

  sendEmailReminder = () => {
    const reminder =
      new SocialInvite(
        this.props.aid,
        null,
        this.props.invite.inviteeEmailAddress,
        null,
        "Hey, this is just a friendly reminder to checkout Cook'n",
        this.props.invite.inviteeFirstName,
        this.props.invite.inviteeLastName)
    sendExternalInvite(reminder,
      () => {
        // Reminder sent Successfully
        this.setState((state, props) => ({
          reminded: true,

          systemMessage: {
            message: 'We sent a reminder to your friend.',
            type: 'success',
            duration: 6000,
            timestamp: new Date().getTime()
          }
        }))
      },
      (error) => {
        // Failed to send reminder
        this.setState((state, props) => ({
          systemMessage: {
            message:
              'There was an error sending a reminder to your friend. Please try again later.',
            type: 'error',
            duration: 6000,
            timestamp: new Date().getTime()
          }
        }))
      })
  }

  sendPhoneReminder = () => {
    const reminder =
      new SocialInvite(
        this.props.aid,
        null,
        null,
        this.props.invite.inviteePhoneNumber,
        "reminder",
        this.props.invite.inviteeFirstName,
        this.props.invite.inviteeLastName)
    sendPhoneInvite(reminder,
      () => {
        // Reminder successfully sent
        this.setState((state, props) => ({
          reminded: true
        }))
      },
      (error) => {
        // Failed to send reminder
        this.setState((state, props) => ({
          systemMessage: {
            message:
              'There was an error sending a reminder to your friend. Please try again later.',
            type: 'error',
            duration: 6000,
            timestamp: new Date().getTime()
          }
        }))
      })
  }

  render() {
    const {
      reminded,

      systemMessage
    } = this.state

    console.log("InviteSent.render: this.props.invite=[" + JSON.stringify(this.props.invite) + "]")
    let firstName = this.props.invite.inviteeFirstName
    let lastName = this.props.invite.inviteeLastName
    const email = this.props.invite.inviteeEmailAddress
    const phone = this.props.invite.inviteePhoneNumber
    console.log("InviteSent.render: " +
      "firstName=[" + firstName + "], " +
      "lastName=[" + lastName + "], " +
      "email=[" + email + "], " +
      "phone=[" + phone + "]")

    // Set a default first and last name if we don't have them
    if (firstName === undefined && lastName === undefined) {
      if (email !== undefined) {
        firstName = "Email"
      } else if (phone !== undefined) {
        firstName = "Phone"
      }
      lastName = "Invite"
    } else if (firstName === undefined && lastName !== undefined) {
      firstName = ""
    } else if (firstName !== undefined && lastName === undefined) {
      lastName = ""
    }

    const name = (firstName + " " + lastName).trim()
    const nameSpan = (
      <span className="invite-name">
        {name}
      </span>
    )

    let emailSpan = ''
    if (email !== undefined) {
      emailSpan = (
        <span className="invite-email-address">
          {email}
        </span>
      )
    }

    let phoneSpan = ''
    if (phone !== undefined) {
      phoneSpan = (
        <span className="invite-phone-number">
          {phone}
        </span>
      )
    }

    let inviteSpan = ''
    if (emailSpan !== '') {
      inviteSpan = (
        <span className="invite-email">
          {nameSpan}
          {emailSpan}
          <Button
            variant="contained"
            color="primary"
            className="invite-tag"
            onClick={e => {
              this.sendEmailReminder()
            }}
            disabled={reminded}
          >
            Remind
          </Button>
        </span>
      )
    } else if (phoneSpan !== '') {
      inviteSpan = (
        <span className="invite-phone">
          {nameSpan}
          {phoneSpan}
          <Button
            variant="contained"
            color="primary"
            className="invite-tag"
            onClick={e => {
              this.sendPhoneReminder()
            }}
            disabled={reminded}
          >
            Remind
          </Button>
        </span>
      )

    } else {
      // This is a Cook'n User, this is an error
    }

    return (
      <div>
        {inviteSpan}
        <SystemMessageSnackbar systemMessage={systemMessage} />
      </div>
    )
  }

}

export default InviteSent



// WEBPACK FOOTER //
// ./src/Components/InviteSent.js